import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';

import { AuthenticationService } from 'psd-common';
import { environment } from '../../../../environments/environment';

@Injectable()
export class AuthorizationGuard implements CanActivate {


  constructor(
    private router: Router,
    private authenticationService: AuthenticationService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.authenticationService.isLoggedIn(environment.production).pipe(
      map(response => {
        if(!response) {
          this.router.navigate(['/central-login/login']);
        }

        return response;
      }));
  }
}
